import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { atLeastOneDaySelectedValidator } from '../../../employees/add-employees/add-employees.component';
import { Drivers } from 'src/app/modules/entry-control/interfaces/drivers';

@Component({
  selector: 'app-add-driver',
  templateUrl: './add-driver.component.html',
  styleUrl: './add-driver.component.css'
})
export class AddDriverComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.driver?.id > 0) {
      this.form.patchValue(this.driver);
      this.form1.patchValue(this.driver);
      this.form1.disable();
      this.form1.get('name')?.setValue(this.driver?.name+' '+this.driver?.lastname);
      this.form.get('stores_id')?.setValue(this.driver?.stores_id);
    }
    if (this.carsId > 0) {
      this.form.get('cars_id')?.setValue(this.carsId);
    }
  }

  @Output()
  success = new EventEmitter<boolean>();

  @Input()
  driver: Drivers;
  @Input()
  carsId: number;
  @Input()
  storesId: number;

  form: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    stores_id: [0],
    cars_id: [0],
    state_id: [0]
  });
  form1: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
  }, { validators: atLeastOneDaySelectedValidator() });

  create() {
    this.api.createDrivers(this.form).subscribe(
      (res) => {
        this.toast.success(res.msg, 'CONDUCTORES');
        this.success.emit(true);
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }



  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1.get('rut')?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
